import { render, staticRenderFns } from "./serviceAndActivite.vue?vue&type=template&id=665bea3d&scoped=true"
import script from "./serviceAndActivite.vue?vue&type=script&lang=js"
export * from "./serviceAndActivite.vue?vue&type=script&lang=js"
import style0 from "./serviceAndActivite.vue?vue&type=style&index=0&id=665bea3d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665bea3d",
  null
  
)

export default component.exports